const Encoding = (value) => {
  return btoa(JSON.stringify(value))
}
const Decoding = (value) => {
  return JSON.parse(atob(value))
}
export {Encoding,Decoding }